// Reads a JSON array out of an API value that may arrive already parsed or still as a JSON string
export const parseJsonArrayValue = (value: unknown): unknown[] => {
  if (Array.isArray(value)) {
    return value;
  }

  if (typeof value !== 'string' || value.trim() === '') {
    return [];
  }

  let parsed: unknown;
  try {
    parsed = JSON.parse(value);
  } catch {
    return [];
  }

  return Array.isArray(parsed) ? parsed : [];
};
